import { useEffect, useState, useRef } from "react";
import "./home.css";
import Slider from "../../Components/Service Partners/Trusted";
import student1 from "../../Images/Home.png";
import student2 from "../../Images/Home.png";
import student3 from "../../Images/Home.png";
import student4 from "../../Images/about.png";
import homeImg7 from "../../Images/homeImg7.jpg";
import homeImg8 from "../../Images/homeImg8.png";
import homeImg9 from "../../Images/homeImg9.jpg";
import homeImg10 from "../../Images/homeImg10.jpg";
import homeImg11 from "../../Images/homeImg11.jpg";
import homeImg12 from "../../Images/homeImg12.png";
import homeImg3 from "../../Images/homeImg3.jpg";
import homeImg4 from "../../Images/homeImg4.jpg";
import homeImg5 from "../../Images/homeImg5.jpg";
import homeImg6 from "../../Images/homeImg6.jpg";
import Advertisement from "../../Components/Cap/Advertisement";
import whatsappIcon from "../../Images/Icons/whatsappIcon.png";
import chatBot from "../../Images/Icons/chatBot.png";
import chooseImg1 from "../../Images/chooseImg1.png";
import chooseImg2 from "../../Images/chooseImg2.png";
import chooseImg3 from "../../Images/chooseImg3.png";
import chooseImg4 from "../../Images/chooseImg4.png";
import Panindia from "../../Components/PAN/panindia";
import homeImg13 from "../../Images/homeImg13.webp";
import homeImg14 from "../../Images/homeImg14.jpg";
import UpcomingEvent from "../../Components/Event1/UpcomingEvent";
import AI from "../../Components/AI/AI";
import Hero from "../../Components/Home/beyon";
import OfferUploader from "../../Components/Offer/offer";
import InternImage from "../../Images/intern.jpeg";

function Home() {
  const handleCallClick = () => {
    window.location.href = "tel:+919380104188"; // Direct call
  };

  const handleWhatsAppClick = () => {
    window.open(
      "https://wa.me/919380104188?text=Hi%20I%20am%20interested%20in%20your%20Capgemini%20training",
      "_blank"
    ); // WhatsApp Business Chat
  };

  const images = [student1, student2, student3];
  const [selectedImage, setSelectedImage] = useState("");
  const observerRef = useRef(null);

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * images.length);
    setSelectedImage(images[randomIndex]);
  }, [images]);

  useEffect(() => {
    // Create observer with proper callback for both directions
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("animate-visible");
              entry.target.classList.remove("animate-hidden");
            }, i * 200);
          } else {
            // When element leaves viewport, remove the visible class
            setTimeout(() => {
              entry.target.classList.remove("animate-visible");
              entry.target.classList.add("animate-hidden");
            }, 100);
          }
        });
      },
      { threshold: 0.2 }
    );

    const elements = document.querySelectorAll(
      ".scroll-left, .scroll-right, .scroll-bounce, .scroll-fade, .scroll-skew"
    );

    elements.forEach((el) => {
      el.classList.add("animate-hidden");
      observerRef.current.observe(el);
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  // popup code
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Check if popup has already been shown in this session
    const popupShown = sessionStorage.getItem("popupShown");

    if (!popupShown) {
      setShowPopup(true);
      sessionStorage.setItem("popupShown", "true"); // Mark popup as shown for this session
    }
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      {/* Popup Advertisement */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <button className="popup-close" onClick={handleClosePopup}>
              ✕
            </button>
            <h2>📢 Latest Updates</h2>
            <p>
              <li> New job opportunities & training sessions are live. </li>
              <li> NSDC programs for all IT and NON IT students </li>
              <li> Internship Program For Both IT & Non IT Students</li>
              <br />
              <a href="/event" className="popup-link">
                Click here
              </a>
            </p>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <div className="hero-section scroll-left">
        <div className="hero-content">
          <h1>
            Career Restorer <br /> Turning Dreams into Careers.
          </h1>
          <p>
            Where ambition meets opportunity. <br />
            Guiding you towards growth and success.
          </p>

          <a href="https://cloudisian-dev-ed.develop.my.site.com/campus/s/">
            <button className="contact-btn1">Apply Now</button>
          </a>
        </div>
        <div className="hero-image">
          <img src={selectedImage} alt="student" />
        </div>
      </div>

      {/* About Section */}
      <div className="about-section scroll-skew">
        <img src={student4} alt="About Career Restorer" />
        <div className="about-text">
          <h2>A Legacy of Trust in People Solutions</h2>
          <p>
            At <strong>Career Restorer</strong>, we go beyond recruitment we
            <span className="highlight"> restore ambitions </span> and
            <span className="highlight"> rebuild futures</span>. Our mission is
            to connect talented individuals with the right opportunities while
            helping organizations discover skilled professionals who drive
            growth. With a strong focus on
            <span className="highlight"> trust</span>,
            <span className="highlight"> excellence</span>, and
            <span className="highlight"> innovation</span>, we provide
            personalized career guidance and strategic placements. From students
            taking their first steps to professionals seeking global
            opportunities, we empower every journey with confidence and clarity.
            More than just filling positions, Career Restorer is about
            <span className="highlight"> creating lasting impact</span>. We
            believe in meaningful connections that unlock potential, inspire
            success, and shape a
            <span className="highlight"> brighter future</span> for individuals
            and businesses worldwide.
          </p>
        </div>
      </div>

     
      <OfferUploader />

      {/* Trusted Partners Slider */}
      <Slider />

      <Panindia />
      <br />

      <UpcomingEvent />

      {/* Work Section */}
      <div className="homeWork2 scroll-bounce">
        <h1>
          Connect Top Talent with Leading Companies Your Trusted Recruitment
          Partner
        </h1>
        <div className="homeWorkBloc2">
          <div className="homeWork2Cards scroll-fade">
            <div className="homeWork2CardsInner">
              <div className="homeWork2CardsFront">
                <img src={homeImg7} alt="Campus Hiring" />
                <h3>Campus Hiring</h3>
              </div>
              <div className="homeWork2CardsBack">
                <h3>Campus Hiring</h3>
                <p>
                  Partnering with top colleges to identify and onboard skilled
                  graduates, ensuring a seamless transition from academics to
                  industry roles.
                </p>
              </div>
            </div>
          </div>

          <div className="homeWork2Cards scroll-fade">
            <div className="homeWork2CardsInner">
              <div className="homeWork2CardsFront">
                <img src={homeImg8} alt="Internship Opportunities" />
                <h3>Internship Opportunities</h3>
              </div>
              <div className="homeWork2CardsBack">
                <h3>Internship Opportunities</h3>
                <p>
                  Offering curated internship programs with top companies to
                  help students gain real-world experience and build in-demand
                  skills.
                </p>
              </div>
            </div>
          </div>

          <div className="homeWork2Cards scroll-fade">
            <div className="homeWork2CardsInner">
              <div className="homeWork2CardsFront">
                <img src={homeImg9} alt="Career Guidance" />
                <h3>Career Guidance</h3>
              </div>
              <div className="homeWork2CardsBack">
                <h3>Career Guidance</h3>
                <p>
                  Expert mentors provide personalized advice, resume tips, and
                  interview coaching to help candidates make informed career
                  choices.
                </p>
              </div>
            </div>
          </div>

          <div className="homeWork2Cards scroll-fade">
            <div className="homeWork2CardsInner">
              <div className="homeWork2CardsFront">
                <img src={homeImg10} alt="Mass Recruitment Drives" />
                <h3>Mass Recruitment Drives</h3>
              </div>
              <div className="homeWork2CardsBack">
                <h3>Mass Recruitment Drives</h3>
                <p>
                  Organizing high-volume recruitment events for companies to
                  quickly hire skilled professionals, saving time and resources
                  for both sides.
                </p>
              </div>
            </div>
          </div>

          <div className="homeWork2Cards scroll-fade">
            <div className="homeWork2CardsInner">
              <div className="homeWork2CardsFront">
                <img src={homeImg11} alt="Resume & Profile Building" />
                <h3>Resume & Profile Building</h3>
              </div>
              <div className="homeWork2CardsBack">
                <h3>Resume & Profile Building</h3>
                <p>
                  We help candidates craft professional resumes and optimize
                  online profiles to impress recruiters and land interviews
                  faster.
                </p>
              </div>
            </div>
          </div>

          <div className="homeWork2Cards scroll-fade">
            <div className="homeWork2CardsInner">
              <div className="homeWork2CardsFront">
                <img src={homeImg12} alt="Skill-Based Job Matching" />
                <h3>Skill-Based Job Matching</h3>
              </div>
              <div className="homeWork2CardsBack">
                <h3>Skill-Based Job Matching</h3>
                <p>
                  Our platform intelligently matches candidates with jobs that
                  fit their skills, interests, and experience, ensuring faster
                  placements and higher satisfaction.
                </p>
              </div>
            </div>
          </div>
          <div className="homeWork2Cards scroll-fade">
            <div className="homeWork2CardsInner">
              <div className="homeWork2CardsFront">
                <img src={homeImg13} alt="Employer Partnerships" />
                <h3>Employer Partnerships</h3>
              </div>
              <div className="homeWork2CardsBack">
                <h3>Employer Partnerships</h3>
                <p>
                  We collaborate with companies to understand their hiring needs
                  and deliver tailored talent solutions that save time and boost
                  productivity.
                </p>
              </div>
            </div>
          </div>

          {/* 8th Card */}
          <div className="homeWork2Cards scroll-fade">
            <div className="homeWork2CardsInner">
              <div className="homeWork2CardsFront">
                <img src={homeImg14} alt="Training & Upskilling" />
                <h3>Training & Upskilling</h3>
              </div>
              <div className="homeWork2CardsBack">
                <h3>Training & Upskilling</h3>
                <p>
                  We offer specialized training programs to enhance candidate
                  skills, making them job-ready and increasing placement success
                  rates.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Domain Section */}
      <div className="domainSection scroll-left">
        <h2>Domains We Cover</h2>
        <div className="domainSectionBlock">
          <div className="domainSectionCard scroll-right">
            <div className="domainSectionImg">
              <img src={homeImg3} alt="homeImg3" />
            </div>
            <div className="domainSectionText">
              <h3>Information Technology</h3>
              <p>
                Software | IT Infrastructure | Artificial Intelligence | Web
                Developer
              </p>
            </div>
          </div>
          <div className="domainSectionCard scroll-right">
            <div className="domainSectionImg">
              <img src={homeImg4} alt="homeImg3" />
            </div>
            <div className="domainSectionText">
              <h3>Banking & Insurance</h3>
              <p>
                Retails Banking | Trade Finance | Micro Finance | SME |
                Relationship
              </p>
            </div>
          </div>
          <div className="domainSectionCard scroll-right">
            <div className="domainSectionImg">
              <img src={homeImg5} alt="homeImg3" />
            </div>
            <div className="domainSectionText">
              <h3>Consumer Services</h3>
              <p>
                B2B & B2C Ecommerce | Education | Edtech | Marketing & Branding
                | Advertising | Media & Entertainment
              </p>
            </div>
          </div>
          <div className="domainSectionCard scroll-right">
            <div className="domainSectionImg">
              <img src={homeImg6} alt="homeImg3" />
            </div>
            <div className="domainSectionText">
              <h3>Financial Services & Consulting</h3>
              <p>
                Retails Banking | Trade Finance | Micro Finance | SME |
                Relationship
              </p>
            </div>
          </div>
        </div>
        <a href="/job">
          <button>Industry</button>
        </a>

        <div className="chooseContainer">
          <h2>Why Choose Us?</h2>
          <div className="chooseWrapper">
            <div className="chooseCards">
              <img src={chooseImg1} alt="chooseImg1" />
              <h2>Experienced Team</h2>
              <p>Our consultants have years of hands-on industry experience.</p>
            </div>
            <div className="chooseCards">
              <img src={chooseImg2} alt="chooseImg2" />
              <h2>Client-Centered Approach</h2>
              <p>Our consultants have years of hands-on industry experience.</p>
            </div>
            <div className="chooseCards">
              <img src={chooseImg3} alt="chooseImg3" />
              <h2>Affordable Pricing</h2>
              <p>Our consultants have years of hands-on industry experience.</p>
            </div>
            <div className="chooseCards">
              <img src={chooseImg4} alt="chooseImg4" />
              <h2>24/7 Support</h2>
              <p>Our consultants have years of hands-on industry experience.</p>
            </div>
          </div>
        </div>
        <Hero />
         <div className="internship-image-wrapper scroll-fade">
        <img
          src={InternImage}
          alt="Internship Program"
          className="internship-image"
        />
      </div>
     

        <Advertisement />
      </div>
      <a href="/">
        <button className="whatsapIcon" onClick={handleWhatsAppClick}>
          <img src={whatsappIcon} alt="whatsappIcon" />
        </button>
      </a>

      <AI />
    </>
  );
}

export default Home;
